/* eslint-disable jira/filename-case */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

import { visualRefreshResolverOverride } from '@jira/platform__services-visual-refresh-rollout/src/resolver-override/index.tsx';
import { getAnalyticsWebClientPromise } from '@jira/platform__observability-product-analytics-web-client-async';
import { initPlatformFeatureFlags } from '@jira/platform__utils-feature-flagging';
// eslint-disable-next-line jira/import/no-restricted-import
import { fg as platformFg } from '@atlaskit/platform-feature-flags/fg';
import { fg } from '@atlassian/jira-feature-gating';

export const initPlatformFeatureFlagsWithMetrics = async (): Promise<void> => {
	initPlatformFeatureFlags(visualRefreshResolverOverride);
	const analyticsClient = await getAnalyticsWebClientPromise();
	analyticsClient.getInstance().sendOperationalEvent({
		action: 'initialised',
		actionSubject: 'platformFeatureGates',
		source: 'jiraSpaEntrypoint',
	});
};

export const verifyPlatformFeatureFlags = (): void => {
	if (
		fg('jfp-magma-always-on-fg-test') !== true ||
		platformFg('jfp-magma-always-on-fg-test') !== true
	) {
		fireErrorAnalytics({
			error: new Error('Always on feature flag mismatch'),
			meta: {
				id: 'init-platform-feature-flags-always-on-mismatch',
				packageName: 'jira-entry',
				teamName: 'JFP - Nike',
			},
		});
	}

	if (
		fg('jfp-magma-always-off-fg-test') !== false ||
		platformFg('jfp-magma-always-off-fg-test') !== false
	) {
		fireErrorAnalytics({
			error: new Error('Always off feature flag mismatch'),
			meta: {
				id: 'init-platform-feature-flags-always-off-mismatch',
				packageName: 'jira-entry',
				teamName: 'JFP - Nike',
			},
		});
	}
};
